module.exports = __webpack_public_path__ + "static/media/mouse-1.2a808589.png";